// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const parasect: PokeData = {
  "id": 47,
  "name": "parasect",
  "height": 10,
  "weight": 295,
  "base_experience": 142,
  "types": [
    PokeType.BUG,
    PokeType.GRASS
  ],
  "api_moves": [
    "scratch",
    "absorb",
    "leech-seed",
    "growth",
    "poison-powder",
    "stun-spore",
    "sleep-powder",
    "screech",
    "leech-life",
    "spore",
    "fury-swipes",
    "slash",
    "giga-drain",
    "fury-cutter",
    "aromatherapy",
    "x-scissor",
    "energy-ball",
    "cross-poison",
    "venoshock",
    "rage-powder"
  ],
  "moves": [
    "scratch",
    "poison-powder",
    "stun-spore",
    "aromatherapy",
    "energy-ball",
    "leech-steal",
    "infest",
    "overgrowth",
    "vine-whip",
    "string-shot",
    "lunge",
    "wood-hammer",
    "leaf-tornado"
  ],
  "evolution_chain": {
    "id": 19,
    "item": null,
    "species": [
      {
        "name": "paras",
        "order": 51,
        "types": [
          PokeType.BUG,
          PokeType.GRASS
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      },
      {
        "name": "parasect",
        "order": 52,
        "types": [
          PokeType.BUG,
          PokeType.GRASS
        ],
        "evolves_from_species_id": 46,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": 24,
            "item": null,
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.LEVEL_UP
            },
            "gender": null
          }
        ]
      }
    ]
  },
  "stats": {
    "resistance": 140,
    "speed": 60,
    "ability_power": 190
  },
  "stat_changes": [],
  "catch_rate": 75,
  "is_legendary": false,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": null
} as const;
